module.exports = __webpack_public_path__ + "img/banner_en.d47fecd4.png";